import { useState } from 'react';
import { useAuth } from '../../../shared/context/AuthContext';
import { useApiError } from '../../../shared/hooks/useApiError';
import authService from '../services/authService';
import { useToast } from '../../../shared/context/ToastContext';

export function useMicrosoftLogin() {
  const [isLoading, setIsLoading] = useState(false);
  const { login } = useAuth();
  const { showError } = useToast();
  
  // Los mensajes por defecto son suficientes
  const { handleError } = useApiError({
    notificationStrategy: {
      showError: showError,
    },
  });

  const handleMicrosoftLogin = async (code: string, redirectUri: string) => {
    setIsLoading(true);

    try {
      const response = await authService.microsoftLogin(code, redirectUri);
      
      // Guarda token y usuario en el contexto
      login(response.token, response.user);
    } catch (err) {
      handleError(err);
    } finally {
      setIsLoading(false);
    }
  };

  return { microsoftLogin: handleMicrosoftLogin, isLoading };
}
